import visibilityIcon from '../../../images/icons/visibility.svg';
import visibilityOffIcon from '../../../images/icons/visibility_off.svg';

/**
 * @file
 * Contains \Drupal\view_password\password.js.
 */
(function ($, once) {
  function PasswordEye($input) {
    if ($input.length === 0) {
      return;
    }

    // Add html to password field.
    const $toggle = $(
      `<button type="button" class="btn-icon password-eye" aria-label="show password">
        ${visibilityIcon}
      </button>`,
    );
    $input.after($toggle);

    $toggle.click(() => {
      const pwdType = $input.attr('type');

      if (pwdType === 'password') {
        $input.attr('type', 'text');
        $toggle.html(visibilityOffIcon);
        $toggle.attr('aria-label', 'hide password');
      } else {
        $input.attr('type', 'password');
        $toggle.html(visibilityIcon);
        $toggle.attr('aria-label', 'show password');
      }
    });
  }

  Drupal.behaviors.viewPassword = {
    attach: function attach(context) {
      $(once('show-password', 'input[type="password"]', context)).each(
        function () {
          PasswordEye($(this));
        },
      );
    },
  };
}(jQuery, once));
